import {
  Component,
  ElementRef,
  HostListener,
  input,
  OnChanges,
  output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { KeyValue, KeyValuePipe, NgStyle } from '@angular/common';
import { FormControl } from '@angular/forms';
import { entries } from '@ps-gui/shared-utils';
import { FloatingElementDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'ct-extraction-dropdown',
  imports: [NgStyle, KeyValuePipe, FloatingElementDirective],
  templateUrl: './dropdown.component.html',
})
export class DropdownComponent implements OnChanges {
  readonly optionLabelByKey = input<Record<string, string>>({});
  readonly header = input.required<string>();

  readonly isOpened = input<boolean>(false);

  readonly control = input.required<FormControl<string | number | undefined | null>>();

  triggerClicked = output<void>();
  selectValue = output<string>();
  outsideClick = output<void>();

  @ViewChild('menuButton') menuButton!: ElementRef<HTMLButtonElement>;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpened']?.currentValue && this.menuButton) {
      this.menuButton.nativeElement.focus();
    }
  }

  @HostListener('window:keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    event.stopPropagation();

    if (event.key === 'Escape') {
      const target = event.target as HTMLButtonElement;
      target.blur();
      return;
    }

    if (this.isOpened()) {
      this.selectOptionByKeycode(event.key);
      event.stopImmediatePropagation();
    }
  }

  selectOptionByKeycode(keyCode: string): void {
    const matchingEntry = entries(this.optionLabelByKey()).find(([_, label]) => {
      return label.toLowerCase().startsWith(keyCode);
    });

    if (!matchingEntry) return;
    this.selectValue.emit(matchingEntry[0]);
  }

  germanSortOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number =>
    a.value.localeCompare(b.value);
}
